export default "__VITE_ASSET__maNgCQWe__"